import React from 'react';

export default function StatusFilter({ value, onChange, counts, t }) {
  const opts = [['all', 'all'], ['in_stock', 'stock_in_stock'], ['low', 'stock_low'], ['out', 'stock_out']];
  return (
    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
      {opts.map(([k, label]) => (
        <button key={k} onClick={() => onChange(k)} className="btn btn-sm"
          style={{ background: value === k ? 'var(--accent)' : 'rgba(255,255,255,0.04)', color: value === k ? '#fff' : 'var(--text-2)', border: '1px solid var(--border)' }}>
          {t(label)} <span style={{ opacity: 0.7 }}>({counts[k] || 0})</span>
        </button>
      ))}
    </div>
  );
}
